import React from "react";
import HeroSection from "./HeroSection";
import RecruitmentSection from "./RecruitmentSection";
import HrSolutions from "./HrSolutions";
import ServicesIndustry from "./ServicesIndustry";
import International from "./International";
import { getMetadataByPage } from "../../API/Api";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
const Service = () => {  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      const data = await getMetadataByPage("home");
      setMetadata(data);
    };
    fetchMetadata();
  }, []);
  return (
    <>
      {/* {metadata && (
        <Helmet>
          <title>{metadata?.title || "Anaxistech"}</title>
          <meta
            name="description"
            content={metadata?.description || "Default description"}
          />
          <meta
            name="keywords"
            content={metadata?.keywords || "tech, services"}
          />
          <meta
            property="og:title"
            content={metadata?.ogTitle || metadata?.title || "Anaxistech"}
          />
          <meta
            property="og:description"
            content={
              metadata?.ogDescription ||
              metadata?.description ||
              "Default description"
            }
          />
          <meta
            property="og:image"
            content={metadata?.ogImage || "/default-image.png"}
          />
        </Helmet>
      )} */}
      <HeroSection />
      <RecruitmentSection />
      <International />
      <HrSolutions />
      <ServicesIndustry />
    </>
  );
};

export default Service;
